export default __webpack_public_path__ + "static/media/logo-menu-text.40cc002b.svg";